// SKYCORE WEBXR.2 — helpers PURS de support WebXR + gating d'accès VR (aucun React, aucune I/O, aucune
// commande de vol). Testables sans DOM/WebGL. `canEnterVR` est l'unique règle de disponibilité du bouton VR.

// Détecte la présence de l'API WebXR (navigator.xr).
export function hasWebXR(nav = typeof navigator !== "undefined" ? navigator : undefined) {
  return !!(nav && nav.xr && typeof nav.xr.isSessionSupported === "function");
}

// Détecte le support d'une session immersive-vr. Retourne "no-webxr" | "unsupported" | "ok".
export async function detectImmersiveVR(nav = typeof navigator !== "undefined" ? navigator : undefined) {
  if (!hasWebXR(nav)) return "no-webxr";
  try {
    const ok = await nav.xr.isSessionSupported("immersive-vr");
    return ok ? "ok" : "unsupported";
  } catch {
    return "unsupported";
  }
}

// Connexions de contrôle CONNUES et INACTIVES (allowlist stricte). Toute autre valeur (open/connecting,
// absente, inconnue) => refus fail-closed.
export const INACTIVE_CONTROL_CONN = new Set(["idle", "closed"]);

// Gating PUR du bouton VR (WEBXR.2H) — fail-closed STRICT : refuse tout état absent, inconnu ou incohérent.
// Autorise UNIQUEMENT un état CONNU : navLocked explicitement false, connexion de contrôle inactive
// (idle|closed), SANS lease (sessionId absent/null) et SANS action critique.
export function canEnterVR(state) {
  if (!state || typeof state !== "object") return false;        // état absent => refus
  const { navLocked, conn, sessionId, criticalAction } = state;
  if (navLocked !== false) return false;                        // doit être explicitement false (true/absent => refus)
  if (!INACTIVE_CONTROL_CONN.has(conn)) return false;           // open/connecting/inconnu/absent => refus
  if (sessionId != null && sessionId !== "") return false;      // lease présente => refus (null/undefined = pas de lease)
  if (criticalAction != null) return false;                     // action critique => refus
  return true;
}

export const XR_SUPPORT_LABEL = {
  checking: "Détection WebXR…",
  ok: "WebXR immersif disponible",
  unsupported: "immersive-vr non supporté",
  "no-webxr": "WebXR indisponible sur ce navigateur",
};
